import Select from 'react-select';
import propTypes from 'prop-types'
import React from 'react'
import colors from "../../../tailwind/_colors.js"

const colourStyles = {
    control: (styles) => ({
        ...styles, backgroundColor: 'white', borderRadius: 20, color: '#A3B3C8', fontSize: 14, paddingLeft: 5,
        paddingRight: 5,
        ':focus': {
            'box-shadow': 'none !important',
        },

    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
        return {
            ...styles,
            fontSize: 14,
            cusror: 'pointer',
            color: colors.secondary[500],
            backgroundColor: colors.secondary[50],
            marginLeft: 10,
            ':active': {
                ...styles[':active'],
                backgroundColor: !isDisabled
                    ? isSelected
                        ? colors.primary[50]
                        : colors.secondary[50]
                    : "white",
            },
            ':hover': {
                backgroundColor: '#E4E9F0',
                color: '#677A8E'
            }
        }
    },
    multiValue: (styles, { data }) => {
        return {
            ...styles,
            backgroundColor: colors?.primary?.[50],
            color: colors?.secondary[400],
            padding: '0 5px',
            borderRadius: 50,
            maxWidth: 75,
            border: `1px solid ${colors?.primary?.[300]}`
        };
    },
    multiValueLabel: (styles, { data }) => ({
        ...styles,
        color: data.color,
    }),
    multiValueRemove: (styles, { data }) => ({
        ...styles,
        color: colors.primary?.[400],
        padding: 0,
        ':hover': {
            color: colors.primary?.[500],
        }
    }),
    input: (styles) => {
        return {
            ...styles,
            boxShadow: 'none !important',
            ':focus': {
                border: '1px solid  red',
                outline: 'none'
            },
            ':active': {
                boxShadow: 'none',
                outline: 'none'
            },
            outline: 'none',

        }
    },
    indicatorsContainer: (base) => ({
        ...base,
        padding: 0 + ' !important',
        margin: 0,
        height:'fit-content'
    })
};

export const CustomMultipleSelect = React.memo(({ options, selected, loader, placeholder, isMulti, onSelect, customComponent, isDisabled, ...rest }) => {

    return (<div className='flex justify-between items-center gap-2'>
        <div className='w-full'>
            <Select
                onChange={onSelect}
                isMulti={isMulti}
                type='text'
                value={selected}
                isSearchable={true}
                placeholder={placeholder}
                {...rest}
                styles={colourStyles}
                isDisabled={isDisabled}
                className='cutom-multi-select'
                options={options} />
        </div>
        {customComponent && <div>{customComponent}</div>}
    </div>)
})

CustomMultipleSelect.propTypes = {
    options: propTypes.array,
    loader: propTypes.bool,
    isMulti: propTypes.bool,
    customComponent: propTypes.element,
    onSelect: propTypes.func,
    selected: propTypes.array

}

CustomMultipleSelect.defaultProps = {
    options: [],
    loader: false,
    isMulti: false,
    customComponent: <></>,
    onSelect: () => { },
    selected: []
}